document.addEventListener('DOMContentLoaded', () => {

const heroes = document.querySelectorAll('.luxury-hero');

heroes.forEach(hero => {

const slider = hero.querySelector('.luxury-hero__slider');
const slides = hero.querySelectorAll('.luxury-slide');

const prev = hero.querySelector('.luxury-arrow--prev');
const next = hero.querySelector('.luxury-arrow--next');

const dots = hero.querySelectorAll('.luxury-dot');

const progress = hero.querySelector('.luxury-progress__bar');

const autoplay =
hero.dataset.autoplay === 'true';

const speed =
(parseInt(hero.dataset.speed) || 5) * 1000;

let current = 0;

let timer;

function updateSlider(){

slider.style.transform =
`translateX(-${current * 100}%)`;

dots.forEach((dot,index)=>{

dot.classList.toggle(
'active',
index===current
);

});

if(progress){

progress.style.transition='none';
progress.style.width='0%';

requestAnimationFrame(()=>{

progress.style.transition=
`width ${speed}ms linear`;

progress.style.width='100%';

});

}

}

function nextSlide(){

current++;

if(current>=slides.length){

current=0;

}

updateSlider();

}

function prevSlide(){

current--;

if(current<0){

current=slides.length-1;

}

updateSlider();

}

function startAutoplay(){

if(!autoplay || slides.length<2){

return;

}

clearInterval(timer);

updateSlider();

timer=setInterval(()=>{

nextSlide();

},speed);

}
function stopAutoplay(){

clearInterval(timer);

}

next?.addEventListener('click',()=>{

nextSlide();

startAutoplay();

});

prev?.addEventListener('click',()=>{

prevSlide();

startAutoplay();

});

dots.forEach((dot,index)=>{

dot.addEventListener('click',()=>{

current=index;

updateSlider();

startAutoplay();

});

});

let startX=0;
let endX=0;

slider.addEventListener('touchstart',(e)=>{

startX=e.touches[0].clientX;

},{passive:true});

slider.addEventListener('touchmove',(e)=>{

endX=e.touches[0].clientX;

},{passive:true});

slider.addEventListener('touchend',()=>{

const diff=startX-endX;

if(Math.abs(diff)>60){

if(diff>0){

nextSlide();

}else{

prevSlide();

}

startAutoplay();

}

});

hero.addEventListener('mouseenter',stopAutoplay);

hero.addEventListener('mouseleave',()=>{

startAutoplay();

});

window.addEventListener('resize',()=>{

updateSlider();

});

updateSlider();

startAutoplay();

});

});